import { 
  collection,
  getDocs,
  doc,
  setDoc,
  query,
  where,
  writeBatch,
  serverTimestamp
} from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { defaultObjectives, defaultPlans } from '@/constants/defaults';

async function initializeCollection(
  collectionName: string,
  defaultData: any[]
) {
  try {
    const collectionRef = collection(db, collections[collectionName]);
    const q = query(collectionRef, where('status', '==', 'active'));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      console.info(`${collectionName} collection already has data`);
      return true;
    }

    const batch = writeBatch(db);
    
    for (const item of defaultData) {
      const docRef = doc(collectionRef, item.id);
      batch.set(docRef, {
        ...item,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    }
    
    await batch.commit();
    console.info(`${collectionName} collection initialized successfully`);
    return true;
  } catch (error: any) {
    if (error.code === 'permission-denied') {
      console.info(`Using default ${collectionName} data due to permissions`);
      return true;
    }
    console.error(`Error initializing ${collectionName}:`, error);
    return false;
  }
}

export async function initializeFirestoreData() {
  try {
    const results = await Promise.all([
      initializeCollection('objectives', defaultObjectives),
      initializeCollection('plans', defaultPlans)
    ]);

    return results.every(Boolean);
  } catch (error) {
    console.warn('Error during collection initialization:', error);
    return false;
  }
}